import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import AxiosApiClient from '../../components/utils/AxiosApiClient';
import AuthUtility from '../../components/frontend/auth/AuthUtility';
import { LogoutService } from '../../components/utils/LogoutService';
import { useOffCanvas } from '../../context/OffCanvasProvider';
import DonatePanel from '../../components/panels//DonatePanel';

import OffCanvasNav from './OffCanvasNav';

import swal from 'sweetalert';

import logo from '../../assets/frontend/images/logo_2.png';

const OnCanvasHeader = () => {

	const { push: openCanvas } = useOffCanvas();  // load offcanvas functions

	//logout should be its own component
	const navHistory = useNavigate();

	var RoleDashboardLink = '';
	var RoleAccountLink = '';
	var RoleSettingsLink = '';
	var RoleFeatureLinks = '';
	var AllLinks = '';

	// member or admin
	if (AuthUtility.isLoggedIn()) {
		RoleAccountLink = '/' + localStorage.getItem('auth_role') + '/profile';
		if (localStorage.getItem('auth_role') === 'member') {
			RoleDashboardLink = '/member/dashboard';
			RoleAccountLink = '/member/account';
			RoleSettingsLink = '/member/settings';

			RoleFeatureLinks = (
				<ul>
					<li className="menu2"><Link to={"/member/videos"} className="font-poppins font-size-14 font-weight-400 uppercase">Videos</Link></li>
					<li className="menu2"><Link to={"/member/payments"} className="font-poppins font-size-14 font-weight-400 uppercase">Payments</Link></li>
				</ul>
			);
		} else if (localStorage.getItem('auth_role') === 'admin') {
			RoleDashboardLink = '/admin/dashboard';
			RoleAccountLink = '/admin/account';
			RoleSettingsLink = '/admin/settings';

			RoleFeatureLinks = (
				<ul>
					<li className="menu2"><Link to={"/admin/plans"} className="font-poppins font-size-14 font-weight-400 uppercase">Plans</Link></li>
					<li className="menu2"><Link to={"/admin/users"} className="font-poppins font-size-14 font-weight-400 uppercase">Users</Link></li>
					<li className="menu2"><Link to={"/admin/subscriptions"} className="font-poppins font-size-14 font-weight-400 uppercase">Subscript</Link></li>
				</ul>
			);
		}

		/*
		AllLinks = (
			<nav className="nav horizontal-container float-right">
				<ul className="element">
					<li className="dropdown text-center">
						<Link to="/home" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Home</Link>
						<ul>
							<li className="menu1"><Link onClick={() => handleComingSoon('About')} className="menu1 font-poppins font-size-14 font-weight-400 uppercase">About</Link></li>
							<li className="menu1"><Link onClick={() => handleComingSoon('Contact')} className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Contact</Link></li>
							<li className="menu1"><Link to="/help" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Help</Link></li>
						</ul>
					</li>
					<li className="dropdown text-center">
						<Link to={RoleDashboardLink} className="menu2 font-poppins font-size-14 font-weight-400 uppercase">Dashboard</Link>
						{RoleFeatureLinks}
					</li>
					<li className="dropdown text-center">
						<Link to={RoleAccountLink} className="menu3 font-poppins font-size-14 font-weight-400 uppercase">{localStorage.getItem('auth_name')}</Link>
						<ul>
							<li className="menu3"><Link to={RoleAccountLink} className="menu3 font-poppins font-size-14 font-weight-400 uppercase">Account</Link></li>
							<li className="menu3"><Link to={RoleSettingsLink} className="menu3 font-poppins font-size-14 font-weight-400 uppercase">Settings</Link></li>
							<li className="menu3"><Link to="#" className="menu3 font-poppins font-size-14 font-weight-400 uppercase" onClick={() => LogoutService({ setIsLoading, navHistory, swal })}>Logout</Link></li>
						</ul>
					</li>
				</ul>
			</nav>
		);
		*/
	} else {

		AllLinks = (
			<nav className="nav horizontal-container justify-right">
				<span className="pr-10">
					<Link className="button medium width-120px"
						onClick={(e) => openDonate(e)}>
						Donate
					</Link>
				</span>

				<ul className="element">
					<li className="dropdown text-center">
						<Link to="/radio" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Radio</Link>
					</li>
					<li className="dropdown text-center">
						<Link to="/podcasts" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Podcasts</Link>
					</li>
					<li className="dropdown text-center">
						<Link to="/home" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Home</Link>
						<ul>
							<li className="menu1"><Link to="/about" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">About</Link></li>
							<li className="menu1"><Link to="/events" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Events</Link></li>
							<li className="menu1"><Link to="/contact" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Contact</Link></li>
							<li className="menu1"><Link to="/help" className="menu1 font-poppins font-size-14 font-weight-400 uppercase">Help</Link></li>
						</ul>
					</li>
				</ul>
			</nav>
		);
	}

	function openDonate(e) {
		e.stopPropagation();

		openCanvas({
			component: DonatePanel,
			props: {
				track: null,
				tracklist: null,
			}
		});
	}

	// Touch handler for mobile focus clearing
	function handleTouchEnd(e) {
		e.currentTarget.blur();
	}

	function handleComingSoon(text) {

		swal("Info", text + " Coming Soon.", "info");
	}

	return (
		<div className="sticky-top z-index-1000">
			<div className="sticky bg-fafafa bb1-ddd plr-20l-10sz">

				<div className="panel large">

					<div id="nav_bar" className="horizontal-container nav-bar">
						<div className="align-left nav-bar-leftX">
							<Link to="/home" className="hover-opacity-50" onClick={(e) => { handleTouchEnd(e); }} onTouchEnd={(e) => { handleTouchEnd(e); }}>
								<div className="horizontal-container justify-left gap-md">
									<span className="hide-for-920px">
										<img src={logo} className="" alt="logo" width="70" />
									</span>
									<span className="show-for-920px">
										<img src={logo} className="hide-for-small-only" alt="logo" width="60" />
										<img src={logo} className="show-for-small-only" alt="logo" width="50" />
									</span>
									<span>
										<div className="font-libre-baskerville font-size-24l-20m-18s font-weight-800 txt-feliz-blue pt-5">Love Leads</div>
										<div className="font-libre-baskerville font-size-24l-20m-18s font-weight-500 txt-feliz-blue pt-10l-5s">&nbsp;&nbsp;&nbsp;<i>the</i> Way</div>
									</span>
								</div>
							</Link>
						</div>
						<div className="align-right nav-bar-rightX hide-for-small-only">
							{AllLinks}
						</div>
						<div className="align-right nav-bar-rightX show-for-small-only">
							<OffCanvasNav />
						</div>
					</div>
				</div>

			</div>
		</div>
	);
}

export default OnCanvasHeader;